import { render, staticRenderFns } from "./AdminDesign.vue?vue&type=template&id=2a5f77bd&scoped=true&"
import script from "./AdminDesign.vue?vue&type=script&lang=js&"
export * from "./AdminDesign.vue?vue&type=script&lang=js&"
import style0 from "./AdminDesign.vue?vue&type=style&index=0&id=2a5f77bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f77bd",
  null
  
)

export default component.exports